<div [hidden]="selectedEntry">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="filter-options">
      <mat-form-field>
        <mat-select
          placeholder="{{ 'contacts.filter_placeholder' | translate }}"
          multiple="multiple"
          #contactTypeSelector
          [(value)]="filterSelection"
        >
          <mat-option *ngFor="let group of groupTypes" [value]="group.type">
            {{ group.text | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="hasDepartments">
        <mat-select
          placeholder="{{ 'contacts.col_department' | translate }}"
          [ngModel]="selectedDepartmentId"
          (ngModelChange)="selectDepartment($event)"
        >
          <mat-option *ngFor="let dep of departments" [value]="dep.id">
            {{ dep.name }}
          </mat-option>
        </mat-select>
        <button *ngIf="selectedDepartmentId > 0" mat-icon-button matSuffix (click)="selectDepartment(0); $event.stopPropagation()">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field>
        <input matInput #filter [(ngModel)]="filterStr" placeholder="{{ 'contacts.filter_contacts' | translate }}" />
        <button mat-icon-button matSuffix (click)="clearFilter()">
          <mat-icon *ngIf="filterStr">clear</mat-icon>
          <mat-icon *ngIf="!filterStr">search</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div>
      <button
        *ngIf="type === contactListTypes.SWB"
        mat-icon-button
        (click)="showClick2Call()"
        matTooltip="{{ 'contacts.call' | translate }}"
        gtDisableWhenNotloggedin
      >
        <mat-icon id="click2call-btn" aria-label="menu-button">phone</mat-icon>
      </button>
      <ng-container *ngIf="type === contactListTypes.SWB || type === contactListTypes.USER">
        <button mat-icon-button (click)="createNewContact()" matTooltip="{{ 'contacts.add_ext' | translate }}">
          <mat-icon id="add-contact-btn" aria-label="menu-button">person_add</mat-icon>
        </button>
        <button
          *gtHasOneOf="[products.NUMBER_LOOKUP_PRODUCT]"
          mat-icon-button
          (click)="showWhitepages()"
          matTooltip="{{ 'contacts.whitepages' | translate }}"
        >
          <mat-icon id="whitepages-btn" aria-label="menu-button">search</mat-icon>
        </button>
      </ng-container>
      <button *ngIf="type === contactListTypes.SWB" mat-icon-button [mat-menu-trigger-for]="menu">
        <mat-icon id="contacts-menu-button" aria-label="menu-button">more_vert</mat-icon>
      </button>
    </div>
  </div>

  <table
    mat-table
    #table
    [dataSource]="dataSource"
    matSort
    id="contacts-list"
    [matSortActive]="sortId"
    [matSortDirection]="sortDirection"
    (matSortChange)="onSort($event)"
  >
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_status' | translate }}</th>
      <td mat-cell *matCellDef="let row">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" [matTooltip]="getMouseOverStatus(row)">
          <mat-icon *ngIf="!row.statusImage" class="status-icon" [ngClass]="row.statusColor">{{ row.statusIcon }}</mat-icon>
          <span *ngIf="row.statusImage"> <img class="status-image" [src]="getDomSanitizedUrl(row)" /></span>
          <span class="status-text" [ngClass]="row.statusColor">
            {{ row.status | translate }}
            <ng-container *ngIf="row.absenceEntry && row.absenceEntry.endTime && row.statusImage">
              {{ 'global.until' | translate }} {{ getEndTime(row) }}
            </ng-container>
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_name' | translate }}</th>
      <td mat-cell *matCellDef="let row">
        <b>{{ row.name }}</b>
      </td>
    </ng-container>

    <ng-container matColumnDef="phoneNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_number' | translate }}</th>
      <td mat-cell *matCellDef="let row">
        <span *ngIf="showNumber(row)">{{ row.phoneNumber | phoneNumberFormatter }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="shortNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_short' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.shortNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_email' | translate }}</th>
      <td mat-cell *matCellDef="let row">
        <a class="color-primary" *ngIf="row.email" href="mailto:{{ row.email }}">{{ row.email }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="department">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_department' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.department }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let row" class="actions">
        <button mat-icon-button><mat-icon color="primary">open_in_new</mat-icon></button>
        <button mat-icon-button><mat-icon color="primary">delete_outline</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="favourite">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let row">
        <div (click)="$event.stopPropagation()">
          <mat-icon id="star-button" aria-label="star-button" *ngIf="row.favourite" (click)="removeContactFavourite(row)">star</mat-icon>
          <mat-icon id="star-border-button" aria-label="star-border-button" *ngIf="!row.favourite" (click)="addContactFavourite(row)"
            >star_border</mat-icon
          >
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <ng-container *ngIf="type === contactListTypes.USER">
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="showContact(row)" class="element-row"></tr>
    </ng-container>
    <ng-container *ngIf="type === contactListTypes.SWB">
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row" [gtCdkDetailRow]="row" [gtCdkDetailRowTpl]="tpl"></tr>
    </ng-container>
  </table>

  <mat-paginator
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 25, 50, dataSource.data.length]"
    (page)="onPageChange($event)"
  >
  </mat-paginator>
</div>

<gt-contact-detail *ngIf="selectedEntry" [contact]="selectedEntry" (back)="backToTable()"></gt-contact-detail>

<ng-template #tpl let-element>
  <tr>
    <td colspan="10">
      <div class="expanded-section" fxLayout="column">
        <gt-mini-calendar
          *ngIf="element.isEndUser()"
          style="width: 100%"
          [oname]="element.oname"
          [login]="element.login"
        ></gt-mini-calendar>
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="16px"
          fxFlexAlign="start"
          style="margin-bottom: 16px; margin-top: 8px"
        >
          <button
            mat-raised-button
            (click)="showClick2Call(element)"
            color="primary"
            *ngIf="!callRegistry.isInCall()"
            class="btn-click2call"
            gtDisableWhenNotloggedin
          >
            {{ 'contact_detail.call' | translate }}
          </button>
          <ng-container *ngIf="callRegistry.isInCall()">
            <button
              mat-button
              *ngIf="enableBlindTransfer(element) | async"
              (click)="transferCall(element.phoneNumber)"
              color="primary"
              class="btn-transfer"
            >
              {{ 'contact_detail.transfer' | translate }}
            </button>
            <button
              mat-button
              *ngIf="enableConsultedTransfer(element) | async"
              (click)="transferCall(element.phoneNumber, true)"
              color="primary"
            >
              {{ 'contact_detail.consult' | translate }}
            </button>
          </ng-container>
          <button mat-button (click)="showContact(element)" color="primary" class="btn-show-contact" *ngIf="!element.isServiceNumber()">
            {{ 'contacts.contact_info' | translate }}
          </button>
          <button
            mat-button
            (click)="showContact(element)"
            color="primary"
            class="btn-show-contact"
            *ngIf="element.isServiceNumber() && element.getMainQueue()"
          >
            {{ 'contacts.queue_settings' | translate }}
          </button>
          <button mat-button (click)="sendSMS(element)" color="primary" class="btn-send-sms" *ngIf="!element.isServiceNumber()">
            {{ 'contacts.send_sms' | translate }}
          </button>
          <button mat-button (click)="showProfile(element)" color="primary" class="btn-show-profile" *ngIf="element.isEndUser()">
            <div *ngIf="!isThisUserOrAdmin(element)">
              {{ 'contacts.show_profile' | translate }}
            </div>
            <div *ngIf="isThisUserOrAdmin(element)">
              {{ 'contacts.show_change_profile' | translate }}
            </div>
          </button>

          <button mat-button (click)="shareContact(element)" *ngIf="canShareContact(element)" color="primary" class="btn-send-contact">
            {{ 'contacts.send_details' | translate }}
          </button>
          <a mat-button color="primary" *ngIf="element.email" href="mailto:{{ element.email }}">{{
            'contacts.send_email' | translate
          }}</a>
        </div>
      </div>
    </td>
  </tr>
</ng-template>

<mat-menu #menu="matMenu">
  <!--<button mat-menu-item (click)="createNewContact()">-->
  <!--Add contact-->
  <!--</button>-->
  <button mat-menu-item (click)="showColumnSettingsDialog()">
    {{ 'contacts.column_settings' | translate }}
  </button>
  <button mat-menu-item (click)="showImportDialog()">
    {{ 'contacts.import' | translate }}
  </button>
</mat-menu>
